<div class="title_div">
  <div class="w-100 d-flex justify-content-between align-items-center">


    <div class="mt-1 d-flex justify-content-start align-items-center">

      <div class="proj_id d-flex">
        <div class="title_sub_div_1 ml-2"> Project Name : {{ this.projectName }} - Version :{{ this.version_id
          }}</div>
      </div>

    </div>



    <div class="title_sub_div_1 title_right_icon_div mr-1">
      <div *ngIf="finalConvertedData.length > 0" style="padding: 3px 0px;" class="btn mr-1"
        title="Export Supply Sense Data as Excel" (click)="exportData()">
        <i class="fas fa-file-export"></i>
      </div>
      <i class="fa fa-home" (click)="home()" title="Dashboard" style="margin-right: 5px;" style="color: black;"></i>
      <!-- <i class="fa fa-arrow-left" (click)="back()" title="Go on part view page"></i> -->
      <i class="fa fa-arrow-left" (click)="showRFQCheckboxes ? cancelRFQ() : back()"
        [title]="showRFQCheckboxes ? 'Back from RFQ' : 'Go on part view page'" style="color: black;">
      </i>
    </div>
  </div>
</div>

<mat-tab-group>
  <mat-tab class="mat_class" label="SUPPLY SENSE">

    <div class="d-flex justify-content-between">
      <div class="d-flex justify-content-start">

        <button type="button" class="btn btn-outline-primary btn-sm" title="Unique Parts" (click)="showAllPartsCount()">
          Number of Parts: <b>{{ uniquePartsCount }}</b>
        </button>


        <button type="button" class="btn btn-outline-primary btn-sm me-2" title="Parts Except N/A"
          (click)="showSourcedParts()">
          Sourced Parts: <b>{{ partsExceptNA }}</b>
        </button>

        <button type="button" class="btn btn-outline-danger btn-sm" title="Parts with N/A Supplier"
          (click)="showUnsourcedParts()">
          Unsourced Parts: <b>{{ partsNA }}</b>
        </button>

        <button type="button" class="btn btn-outline-primary btn-sm" title="Total Sum">
          Project Cost: <b> ₹ {{ projectCost | number:'1.0-0' }}</b>
        </button>
      </div>


      <div class="d-flex justify-content-end">

        <!-- Fetch Suppliers (hidden initially) -->
        <button *ngIf="showFetch" type="button" class="btn btn-outline-primary btn-sm" title="fetch suppliers"
          (click)="fetchsuppliers()">
          Fetch Suppliers
        </button>

        <!-- Q-Sourcing Stat button (always shown) -->
        <button type="button" class="btn btn-outline-primary btn-sm" title="Q-Sourcing Stat" (click)="QSourcing()">
          Q-Sourcing Stat
        </button>

        <!-- Send RFQ (hidden when Fetch Suppliers is shown) -->
        <button *ngIf="!showFetch" type="button" class="btn btn-outline-primary btn-sm" title="Send RFQ"
          (click)="sendRFQ()">
          Send RFQ
        </button>
        <!-- <button *ngIf="showRFQCheckboxes" type="button" class="btn btn-outline-primary btn-sm" title="Back"
  (click)="cancelRFQ()">
  Back
</button> -->

        <button *ngIf="projectStatus === 'Open'" type="button" class="btn btn-outline-primary btn-sm" title="Submit"
          (click)="openPopup(offerPriceModal)">
          Submit
        </button>

      </div>

    </div>
    <div class="row row_mar mt-1">
      <div class="col-12 grid-margin stretch-card col_pad">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive gd_main_div_mobile">
              <table class="table table-striped custom-hover">
                <thead>
                  <tr>
                    <th *ngIf="showRFQCheckboxes">
                      <input type="checkbox" [checked]="isAllSelected()" (change)="toggleAllSelection($event)" />
                    </th>
                    <th>Internal Part No</th>
                    <th>MPN</th>
                    <th>MPN(Match)</th>
                    <th>Make</th>
                    <th>Commodity</th>
                    <th>UOM</th>
                    <th>Quantity</th>
                    <th>Finalized Supplier</th>
                    <th></th>
                    <th>COP</th>
                    <th>Stock</th>                   
                    <th>MOQ</th>
                    <th>SPQ</th>
                    <th>Lead Time</th>
                    <th> Basic Price</th>
                    <th>Currency</th>
                    <th>Basic Price (INR)</th>
                    <th>Est.Landing Cost</th>                   
                    <th>Total Cost (INR)</th>
                    <th>PO History</th>
                    <th>Risk (Inv,LT,Price)</th>
                  </tr>
                </thead>
                <tbody>

                  <tr *ngFor="let row of filteredData; let i = index"
                    [ngClass]="{'highlight-row': row.internalPartNo === highlightedIPN}"
                    [ngStyle]="highlightNA && row?.supplier  === 'N/A' ? {'background-color': '#ffff99'} : {}">
                    <td *ngIf="showRFQCheckboxes">
                      <input type="checkbox" [checked]="rfqSelected[row.internalPartNo]"
                        (change)="onRFQCheckboxChange(row, $event)"  />
                    </td>
                    <!-- [disabled]="row.supplier === 'N/A'" -->
                    <td class="partNo_td" (click)="onPartInfo(row)">{{ row?.internalPartNo }}</td>

                    <td>{{ row?.specification }}</td>
                    <td>{{ row?.MPN }}</td>
                    <td>{{ row?.manufacturer }}</td>
                    <td>{{ row?.commodity }}</td>
                    <td>{{ row?.uom }}</td>
                    <td>{{ row?.projectQty }}</td>
                    <td>{{ row?.supplier }}</td>
                    <td></td>
                    <td>{{ row?.country
                      }}</td>
                    <td>{{ row?.Inventorylevel }}</td>
                    <td>{{ row?.MOQ }}</td>
                    <td>{{ row?.Closest_Quantity}}</td>
                    <td>{{ getLeadTimeToShow(row) }}</td>
                    <td>{{ row?.Price }}</td>
                    <td>{{ row?.Currency }}</td>
                    <td>{{ row?.ConvertedPrice | number:'1.2-2' }}</td>
                    <td>{{ row?.landing_cost }}</td>
                    <td>{{ row?.total_value_inr | number:'1.2-2' }}</td>
                    <td>
                      <a *ngIf="row.isPoExist === 'Yes'" href="javascript:void(0)" (click)="onPoDataClick(row)">
                        Available
                      </a>

                      <span *ngIf="row.isPoExist !== 'Yes'" style="font-weight: normal;">
                        No Records
                      </span>

                    </td>

                    <td>
                      <span class="risk-indicator"
                        [ngStyle]="{ 'background-color': getRiskColor(row.projectQty, row.Inventorylevel) }">
                      </span>

                      <span class="risk-indicator"
                        [ngStyle]="{ 'background-color': getLeadTimeColor(row.projectQty, row.Inventorylevel, row.leadTime) }">
                      </span>

                      <span class="risk-indicator" [ngStyle]="{ 'background-color': row.priceColor }">
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="PART PULSE">
    <div>
      <!-- <p>This is the PART PULSE tab.</p> -->
      <ngx-analysis></ngx-analysis>

    </div>
  </mat-tab>
  <mat-tab label="COMPARE">
    <div>
      <div class="dropdown-container">
        <div class="d-flex justify-content-between">
          <!-- First Dropdown -->

          <div class="d-flex justify-content-start">
            <div class="dropdown">
              <label for="compare1">Compare</label>
              <select id="compare1" [(ngModel)]="customerInfoData.currentstage">
                <option [value]="customerInfoData.currentstage">{{ customerInfoData.currentstage }}</option>
              </select>
              <select id="subCompare1" *ngIf="customerInfoData.currentstage" [(ngModel)]="selectedFirstSubOption"
                (change)="onSubDropdownChange('first')">
                <option value="" selected disabled>--Select--</option>
                <option *ngFor="let subOption of firstSubOptions" [value]="subOption">{{ subOption }}</option>
              </select>
            </div>
            <div class="d-flex justify-content-start">
              <button type="button" class="btn btn-outline-primary btn-sm" title="Unique Parts">
                Total Parts: <b>{{ uniquePartsSize }}</b>
              </button>
              <button type="button" class="btn btn-outline-primary btn-sm" title="Parts Expect N/A">
                Sourced Parts: <b> {{ partsExceptNACompare}} </b>
              </button>
              <button type="button" class="btn btn-outline-primary btn-sm" title="Total Sum">
                Total Cost: <b> ₹ {{ totalSuminCompare | number:'1.0-0' }}</b>
              </button>

            </div>
          </div>
          <div class="d-flex justify-content-end">
            <!-- Second Dropdown -->
            <div class="dropdown">
              <label for="compare2">With</label>
              <select id="compare2" [(ngModel)]="customerInfoData.currentstage">
                <option [value]="customerInfoData.currentstage">{{ customerInfoData.currentstage }}</option>
              </select>
              <select id="subCompare2" *ngIf="customerInfoData.currentstage" [(ngModel)]="selectedSecondSubOption"
                (change)="onSubDropdownChange('second')">
                <option value="" selected disabled>--Select--</option>
                <option *ngFor="let subOption of secondSubOptions" [value]="subOption">{{ subOption }}</option>
              </select>
            </div>
          </div>
          <div class="d-flex justify-content-start">
            <button type="button" class="btn btn-outline-primary btn-sm" title="Unique Parts">
              Total Parts: <b>{{ uniquePartsWith }}</b>
            </button>
            <button type="button" class="btn btn-outline-primary btn-sm" title="Parts Expect N/A">
              Sourced Parts: <b> {{ partsExceptNAWith}} </b>
            </button>
            <button type="button" class="btn btn-outline-primary btn-sm" title="Total Sum">
              Total Cost: <b> ₹ {{ totalSuminwith | number:'1.0-0' }}</b>
            </button>

          </div>
        </div>
      </div>
      <div *ngIf="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
      <div class="d-flex justify-content-between">
        <div class="d-flex justify-content-start">
          <div class="row row_mar mt-1">
            <div class="col-12 grid-margin stretch-card col_pad">
              <div class="card">
                <div class="card-body">
                  <div class="table-responsive gd_main_div_mobile">
                    <table class="table table-striped custom-hover">
                      <thead>
                        <tr>

                          <th>MPN</th>
                          <th>Make</th>
                          <th>Supplier</th>
                          <th>Stock</th>
                          <th>UOM</th>
                          <th>Price</th>
                          <th>UOC</th>
                          <th>MOQ</th>
                          <th>Lead Time</th>
                          <th>ABC Rating</th>
                          <th>Landing Cost</th>
                           <th>Total Cost (INR)</th>
                          <th>Risk (Inv,LT,Price)</th>
                          <th>IPN</th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngFor="let itemList of filteredFirstTableData">
                          <tr *ngFor="let row of itemList.parts">

                            <td>{{ row?.MPN }}</td>
                            <td>{{ row?.manufacturer }}</td>
                            <td>{{ row?.supplier }}</td>
                            <td>{{ row?.Closest_Quantity }}</td>
                            <td>{{ row?.uom }}</td>
                            <td>{{ row?.Price | number:'1.2-2' }}</td>
                            <td>{{ row?.Currency }}</td>
                            <td>{{ row?.MOQ }}</td>
                            <td>{{ row?.leadTime }}</td>
                            <td>{{ row?.abcRating }}</td>
                            <td>{{ row?.landing_cost }}</td>
                              <td>{{ row?.total_value_inr | number:'1.2-2' }}</td>

                            <td>
                              <span class="risk-indicator"
                                [ngStyle]="{ 'background-color': getRiskColor(row.projectQty, row.Inventorylevel) }">
                             
                               
                              </span>
                          
                                <span class="risk-indicator"
                        [ngStyle]="{ 'background-color': getLeadTimeColor(row.projectQty, row.Inventorylevel, row.leadTime) }">
                        
                      </span>

                              
                              <span class="risk-indicator" [ngStyle]="{ 'background-color': row.priceColor }">
                               
                              </span>
                            </td>

                            <td (click)="onIpnClick(row.internalPartNo)" style="cursor: pointer; color: blue;">
                              {{ row.internalPartNo }}   
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end">
          <div class="row row_mar mt-1">
            <div class="col-12 grid-margin stretch-card col_pad">
              <div class="card">
                <div class="card-body">
                  <div class="table-responsive gd_main_div_mobile">
                    <table class="table table-striped custom-hover">
                      <thead>
                        <tr>
                          <th>IPN</th>
                          <th>MPN</th>
                          <th>Make</th>
                          <th>Supplier</th>
                          <th>Stock</th>
                          <th>UOM</th>
                          <th>Price</th>
                          <th>UOC</th>
                          <th>MOQ</th>
                          <th>Lead Time</th>
                          <th>ABC Rating</th>
                          <th>Landing Cost</th>
                           <th>Total Cost (INR)</th>
                          <th>Risk (Inv,LT,Price)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngFor="let itemList of filteredSecondTableData">
                          <tr *ngFor="let row of itemList.parts"
                            [ngClass]="{ 'highlight-row': row.internalPartNo === highlightedIpn }">
                            <td>{{ row?.internalPartNo }}</td>
                            <td>{{ row?.MPN }}</td>
                            <td>{{ row?.manufacturer }}</td>
                            <td>{{ row?.supplier }}</td>
                            <td>
                              {{ row?.Closest_Quantity }}

                              <span *ngIf="getStockComparisonArrow(row) === 'up'"
                                class="arrow up stock-up stock-change">
                                +{{ getStockDifference(row) }}
                              </span>

                              <span *ngIf="getStockComparisonArrow(row) === 'down'"
                                class="arrow down stock-down stock-change">
                                {{ getStockDifference(row) }}
                              </span>
                            </td>
                            <td>{{ row?.uom }}</td>
                            <td>
                              {{ row?.Price | number:'1.2-2' }}
                              <!-- <span *ngIf="getPriceComparisonArrow(row) === 'up'"
                                class="arrow up price-up stock-change">
                                +{{ getPriceDifference(row) | number:'1.2-2' }}
                              </span>
                              <span *ngIf="getPriceComparisonArrow(row) === 'down'"
                                class="arrow down price-down stock-change ">
                                {{ getPriceDifference(row) | number:'1.2-2' }}
                              </span> -->
                            </td>
                            <td>{{ row?.Currency }}</td>
                            <td>{{ row?.MOQ }}</td>
                            <td>{{ row?.leadTime }}</td>
                            <td>{{ row?.abcRating }}</td>
                            <td>{{ row?.landing_cost }}</td> 
                              <td>{{ row?.total_value_inr | number:'1.2-2' }}</td>                          
                            <td>
                              <span class="risk-indicator"
                                [ngStyle]="{ 'background-color': getRiskColor(row.projectQty, row.Inventorylevel) }">
                              </span>
                          
                                <span class="risk-indicator"
                        [ngStyle]="{ 'background-color': getLeadTimeColor(row.projectQty, row.Inventorylevel, row.leadTime) }">
                      </span>

                              <span class="risk-indicator" [ngStyle]="{ 'background-color': row.priceColor }">
                              </span>
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>

<ng-template #offerPriceModal let-modal>

  <div class="modal-body">
    <p class="modal-title">Do you want to close the Project</p>
  </div>

  <div class="modal-footer">
    <button type="submit" class="btn btn-outline-primary btn-sm" [disabled]="isProjectNameDuplicate" title="Save"
      (click)="saveProjectViewData()">Yes</button>
    <button type="button" class="btn btn-outline-primary btn-sm" title="Close" (click)="closePopup()">No</button>
  </div>
</ng-template>
<div *ngIf="isLoading" class="loading-bar">
</div>